import { render, staticRenderFns } from "./myInfomation.vue?vue&type=template&id=bd05981e&scoped=true"
import script from "./myInfomation.vue?vue&type=script&lang=js"
export * from "./myInfomation.vue?vue&type=script&lang=js"
import style0 from "./myInfomation.vue?vue&type=style&index=0&id=bd05981e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd05981e",
  null
  
)

export default component.exports